import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'BooleanWidget';

const classes = {
  bgHover: `${PREFIX}-bgHover`
};

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  [`& .${classes.bgHover}`]: {
    '&:hover': {
      background: theme.palette.primary.light
    }
  }
}));

const BooleanWidget = ({ value, setValue, field }: any) => {
  const onChange = (event: any) => {
    setValue(event.target.value);
  };

  return (
    <StyledFormControl variant="outlined" fullWidth data-testid="booleanSelectForm">
      <Select
        className={classes.bgHover}
        value={value}
        displayEmpty
        onChange={onChange}
        inputProps={{
          id: field,
          'data-testid': `boolean-widget-${field}`
        }}
      >
        <MenuItem value="True" data-testid="booleanSelectForm-true">
          True
        </MenuItem>
        <MenuItem value="False" data-testid="booleanSelectForm-false">
          False
        </MenuItem>
      </Select>
    </StyledFormControl>
  );
};

export default BooleanWidget;
